<div class="footer">
  <div class="footer-content">
    <a routerLink="/">
      <h3>Jona<span>s</span></h3>
    </a>
    <p>© Jonas Valtin 2025</p>
    <div class="socials">
      <a href="https://github.com/VaJoLe">
        <img src="assets/icons/Github-small.png" alt="Github" />
      </a>
      <a href="#contact">
        <img src="assets/icons/Email-small.png" alt="Email" />
      </a>
      <a href="https://de.linkedin.com/">
        <img src="assets/icons/Linkedin-small.png" alt="LinkedIn" />
      </a>
    </div>
  </div>
  <a routerLink="/imprint"> {{ "FOOTER.IMPRINT" | translate }} </a>
</div>
